module.exports = __webpack_public_path__ + "img/Galactapedia_Musashi_Industrial_and_Starflight_Concern_MISC.4be99b7e.png";